module.exports = __webpack_public_path__ + "static/face-2-aa9878de5cd8c50a7d931e4c012a21d6.png";